/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sgrp_Event_RuntimeInputs */

const en_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EVENT RUNTIME`)
};

const ar_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيئة التشغيل`)
};

const bn_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইভেন্ট রানটাইম`)
};

const de_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EREIGNISLAUFZEIT`)
};

const es_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIEMPO DE EJECUCIÓN DEL EVENTO`)
};

const fr_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURÉE D'ÉVÉNEMENT`)
};

const pt_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TEMPO DE EXECUÇÃO DO EVENTO`)
};

const zh_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件运行时间`)
};

const tr_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETKİNLİK ÇALIŞMA ZAMANI`)
};

const ru_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ВРЕМЯ ПРОВЕДЕНИЯ СОБЫТИЯ`)
};

const pl_sgrp_event_runtime = /** @type {(inputs: Sgrp_Event_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CZAS DZIAŁANIA ZDARZENIA`)
};

/**
* | output |
* | --- |
* | "EVENT RUNTIME" |
*
* @param {Sgrp_Event_RuntimeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const sgrp_event_runtime = /** @type {((inputs?: Sgrp_Event_RuntimeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sgrp_Event_RuntimeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_sgrp_event_runtime(inputs)
	if (locale === "bn") return bn_sgrp_event_runtime(inputs)
	if (locale === "de") return de_sgrp_event_runtime(inputs)
	if (locale === "es") return es_sgrp_event_runtime(inputs)
	if (locale === "fr") return fr_sgrp_event_runtime(inputs)
	if (locale === "pt") return pt_sgrp_event_runtime(inputs)
	if (locale === "zh") return zh_sgrp_event_runtime(inputs)
	if (locale === "tr") return tr_sgrp_event_runtime(inputs)
	if (locale === "ru") return ru_sgrp_event_runtime(inputs)
	if (locale === "pl") return pl_sgrp_event_runtime(inputs)
	return en_sgrp_event_runtime(inputs)
});